import { createTheme } from '@mui/material';

export const GLOBAL_STYLES = {
  html: {
    overflowY: 'scroll' as 'scroll', // TODO: fix this
  },
  ul: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  img: {
    maxWidth: '100%',
  },
}

export const CREATED_THEME = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'always',
      },
    },
  },
});